<template>
  <section id="section-3" class="content-current">
    <hotel-booking-modal :reserveId="reserveId" v-if="showModal" @btnClose="close">
      <div style="text-align: center" slot="body">
        <h4 style="margin-top: 10px">
          زمان شما برای ورود اطلاعات مسافرین به پایان رسیده
        </h4>
      </div>
    </hotel-booking-modal>
    <div class="">
      <div class="row">
        <div class="col-md-11"></div>
        <div class="col-md-1">
          <router-link to="/profile/dashboard">
            <div title="بازگشت به داشبورد" class="close"></div>
          </router-link>
        </div>
      </div>
      <div class="content-current">

        <div class="row">
          <!-- <div class="col-12" style="text-align: center;" > سامانه رزرواسیون پردیس داریوش کیش</div> -->

          <div class="col-md-6">

            <label class="">از تاریخ: </label>
            <date-picker v-model="fromDate" display-format="jYYYY/jMM/jDD" color="#00C3E1"  popover="bottom-right" auto-submit locale="fa" />
          </div>

          <div class="col-md-6">
            <label class="">تا تاریخ: </label>
            <date-picker v-model="toDate" display-format="jYYYY/jMM/jDD" color="#00C3E1"  popover="bottom-right" auto-submit locale="fa" />
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group" style="margin-top: 35px">
            <label class="lbl-report"> وضعیت رزرو :</label>

            <div class="form-check-inline" v-for="status in statusList">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" :value="status.id" v-model="bookingStatus" />
                {{ status.title }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group" style="margin-top: 35px">
            <label class="lbl-report"> نوع پرداخت:</label>

            <div class="form-check-inline" v-for="pay in paymentList">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" :value="pay.id" v-model="paymentMethod" />
                {{ pay.title }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 btn-align">
          <button type="submit" class="btn btn-primary" @click="search">
            جستجو
          </button>
        </div>
      </div>


    </div>
    <hr />
    <div class="col-md-12 loading" v-if="isLoading">
      <loadingBar type="ripple" />
    </div>
    <div class="scrollable">
      <div>
        <table class="table tablesorter add_bottom_30" v-if="!isLoading">
          <thead class="thead-light">
            <tr>
              <th>شماره رزرو</th>
              <th>تاریخ رزرو</th>
              <th>نام مهمان</th>
              <th>فروشنده</th>
              <th>ورود</th>
              <th>خروج</th>
              <!-- <th>پرداخت شده (ريال)</th> -->
              <th>چاپ واچر</th>
              <th>چاپ واچر مشتری</th>
              <th>جزئیات</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in reservedList">
              <tr>
                <td>{{ item.reserveNumber }}</td>
                <td>{{ item.shamsiDate }}</td>
                <td>{{ item.individualName }}</td>
                <td>{{ item.sourceName }}</td>
                <td>{{ item.shamsiArrivalDate }}</td>
                <td>{{ item.shamsiDepartureDate }}</td>
<!-- 
                <td>{{ item.totalPayed | numFormat }}</td> -->

                <td v-if="item.reserveNumber" class="td-detail" @click="printBook(item.id)">
                  <i class="icon-print-2" style="color: #08446a; font-size: 20px"></i>
                </td>

                <td v-else class="td-detail">
                  <i class="icon-print-2" style="color: gray; font-size: 20px"></i>
                </td>

                <td v-if="item.reserveNumber" class="td-detail" @click="printCustomerBook(item.id)">
                  <i class="icon-print" style="color: #e04f67; font-size: 20px"></i>
                </td>

                <td v-else class="td-detail">
                  <i class="icon-print" style="color: gray; font-size: 20px"></i>
                </td>

                <td class="td-detail" @click="toggle(index + 1)" :class="{ opened: opened.includes(index + 1) }">
                  <i class="icon-th" style="color: #008489; font-size: 20px"></i>
                </td>
              </tr>
              <transition name="fade">
                <template>
                  <tr v-if="opened.includes(index + 1)">
                    <td class="td-opened" colspan="3">
                      <p v-if="item.isPayed">وضعیت پرداخت : پرداخت شده</p>
                      <p v-else>وضعیت پرداخت : پرداخت نشده</p>
                    </td>
                    <td class="td-opened" colspan="3">
                      <p v-if="item.iscancelled">وضعیت رزرو: کنسل شده</p>
                      <p v-else-if="item.status == 'P'">وضعیت رزرو: موقت</p>
                      <p v-else="item.status == 'C'">وضعیت رزرو: تائید شده</p>
                    </td>

                    <td class="td-opened" colspan="2">
                      <p>نفر : {{ item.pax }}</p>
                    </td>
                    <td class="td-opened" colspan="2">
                      <p>اتاق : {{ item.numberOfRoom }}</p>
                    </td>
                  </tr>
                </template>
              </transition>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="btn-align">
      <h3 v-if="!hasShowResult">نتیجه ای یافت نشد !!!!</h3>
    </div>

  </section>
</template>

<script>
import Store from "../../../../views/profile/store/index";
import moment from "moment-jalaali";
import loadingBar from "../../../../components/loading/pdkLoadingBar";
import HotelBookingModal from "./HotelBookingModal";
import date from "../../../../utils/date";
// import datePicker, { PersianDate } from "@alireza-ab/vue-persian-datepicker";


export default {
  name: "creditReport",
  store: Store,
  components: { loadingBar, HotelBookingModal },
  data() {
    return {
      min: moment(new Date()).format("jYYYY/jMM/jDD"),
      now: moment(),
      isLoading: false,
         fromDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      toDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      reservedList: [],
      opened: [],
      bookingStatus: "all",
      paymentMethod: "all",
      voucherNumber: "",
      isModalVisible: false,
      showModal: false,
      hasShowResult: false,
      showTimerModal: false,
      reserveId: 0,
      statusList: [
        { id: "all", title: "همه" },
        { id: "pending", title: "موقت" },
        { id: "approved", title: "تایید شده" },
        { id: "cancelled", title: "کنسل شده " },
      ],
      paymentList: [
        { id: "all", title: "همه" },
        { id: "B", title: "نقدی" },
        { id: "C", title: "اعتباری (Credit) " },
        { id: "D", title: "اعتباری (Deposit)" },
      ],
    };
  },
  methods: {
    // convertDate(date) {
    //   if (date === "0001-01-01T00:00:00") return "";
    //   if (!moment(date).isValid()) return "";
    //   const pdate = moment(date).format("jYYYY/jMM/jDD");
    //   return pdate;
    // },

    async search() {
     
      const data = {
        fromDate: date.ConvertToGregorian(this.fromDate),
        toDate: date.ConvertToGregorian(this.toDate),
        sourceId: localStorage.getItem("SourceIdInReport"),
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        bookingStatus: this.bookingStatus,
        paymentMethod: this.paymentMethod,
      };
  
      this.isLoading = true;

      this.reservedList = await this.$store.dispatch(
        "getReservedHotelCrs",
        data
      );
     
      this.isLoading = false;
      if (this.reservedList.length) this.hasShowResult = true;
  
    },
    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    },
    close() {
      this.showModal = false;
    },
    showBookingModal(id) {
      this.showModal = true;
      this.reserveId = id;
    },

    printBook(id) {
      let route = this.$router.resolve("/profile/printhotelbooking/" + id);
      window.open(route.href, "_blank");
    },
    printCustomerBook(id) {
      let route = this.$router.resolve(
        "/profile/printcustomerhotelbooking/" + id
      );
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style scoped>
.content section {
  min-height: 800px;
  border-radius: 0;
  border: none !important;
}

@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
}

.page-link {
  position: relative !important;
  display: block !important;
  padding: 0.5rem 0.75rem !important;
  margin-left: -1px !important;
  line-height: 1.25 !important;
  color: #2a69b1 !important;
  background-color: #fff !important;
  border: 1px solid #dee2e6 !important;
}

.page-link:hover {
  z-index: 2;
  color: #0056b3 !important;
  text-decoration: none !important;
  background-color: #e9ecef !important;
  border-color: #dee2e6 !important;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #2a69b1 !important;
  border-color: #2a69b1 !important;
}

.btn-profile {
  width: 180px !important;
}

.btn-align {
  margin-top: 20px !important;
}

.icon-top {
  margin-top: 38px;
  font-size: 40px;
}

.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}

.icon-position {
  float: left;
  margin-left: 26px;
}

.td-opened {
  background-color: rgb(4 112 167) !important;
  color: white;
}

.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}

h3 {
  color: #777 !important;
}

.td-detail {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>

<style scoped lang="scss">
.scrollable {
  overflow: hidden;
  position: relative;
  width: 100%;

  &.is-scrollable:after {
    position: absolute;
    top: 0;
    left: 100%;
    width: 50px;
    height: 100%;
    border-radius: 10px 0 0 10px / 50% 0 0 50%;
    box-shadow: -5px 0 10px rgba(0, 0, 0, 0.25);
    content: "";
  }

  // the overflow-er
  >div {
    overflow-x: auto;

    // forces scrollbar for webkit
    ::-webkit-scrollbar {
      height: 12px;
    }

    ::-webkit-scrollbar-track {
      background: #f0f0f0;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.15) inset;
    }

    ::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 6px;
    }
  }
}
</style>